import React, {useCallback, useState} from 'react';
import {Link, useNavigate} from 'react-router-dom';

import {useHttpClient} from '../../../common/hook/http';

import GlobalConst from '../../../common/global-const';

import FormElement from "../../../common/component/FormElement/FormElement";
import {useFrom} from "../../../common/hook/form";
import setNativeValue from "../../../common/util/set-native-value";

import NoContent from "../../../common/component/NoContent/NoContent";
import Loader from '../../../common/component/Loader/Loader';

import {Modal, Row, Col, Button, Form} from 'react-bootstrap';

import * as IconFi from 'react-icons/fi';

import './CustomerClub.scss';

const ModalCustomerClub = props => {
    const {callAPI} = useHttpClient()
    const navigate = useNavigate()

    // ------------------------------------------------------------------------------------------------------------ data

    const [data, setData] = useState(null)

    // ------------------------------------------------------------------------------------------------ on show and hide

    const handlePopstate = useCallback(() => {

        if (document.querySelectorAll('.modal').length < 2)
            window.removeEventListener('popstate', handlePopstate)

        props.onHide()

    }, [])

    const onShowHandler = () => {

        document.getElementById('modalCustomerClub').style.paddingRight = document.querySelector('body').style.paddingRight

        navigate(`#modalCustomerClub`)
        window.addEventListener('popstate', handlePopstate);

        // با هر بار باز شدن مودال دریافت اطلاعات نمایش داده شود
        setData(null)

        const fetchData = async () => {
            try {
                const responseData = await callAPI(
                    `club/shops`,
                );

                // console.log(responseData)

                if (responseData.message) {

                } else {

                    setData(responseData)

                }

            } catch (e) {
                console.error(e);
            }
        }

        fetchData()

    }

    const onHideHandler = () => {

        navigate(-1)

    }

    // -----------------------------------------------------------------------------------------------------------------

    const [formState, inputHandler] = useFrom({
        formCustomerClubKeyword: {
            value: '',
            isValid: false
        }
    }, false);

    const searchResetHandler = e => {

        e.stopPropagation()

        setNativeValue('formCustomerClubKeyword', '')

    }

    // -----------------------------------------------------------------------------------------------------------------

    return (
        <Modal id="modalCustomerClub" aria-labelledby="modalCustomerClubTitle" {...props} fullscreen backdrop={false} onHide={onHideHandler} onShow={onShowHandler} className="ltr bg-body" dialogClassName={`rtl${data ? ' h-auto' : ''}`} contentClassName="container-lg px-0">
            <Modal.Header className="position-sticky top-0">
                <Button variant="link" onClick={onHideHandler} className="my-md-1 text-reset border-0 btn-icon d-md-none"><IconFi.FiArrowRight size={24} className="sw-1 m-2"/></Button>
                <Modal.Title className="me-4 pe-3 flex-grow-1 text-center text-md-start fs-5 text-truncate">فهرست باشگاه مشتریان</Modal.Title>
                <Button variant="link" onClick={onHideHandler} className="my-md-1 text-reset border-0 btn-icon d-none d-md-inline-block"><IconFi.FiX size={24} className="sw-1 m-2"/></Button>
            </Modal.Header>
            {
                data ? (
                    <Modal.Body className="overflow-visible pt-0">
                        <Row className="gx-3 gy-4">
                            <Col xs={12}>
                                <Form id="formCustomerClub" autoComplete="off">
                                    <FormElement component="INPUT" type="text" id="formCustomerClubKeyword" name="term" placeholder="جستجو" className="bg-elevate-4 border-0 ps-0" onInput={inputHandler}
                                                 prepend={<Button variant="link" className="bg-elevate-4 border-0 text-white text-opacity-38 btn-icon"><IconFi.FiSearch size={24} className="sw-1 flip-h"/></Button>}
                                                 append={formState.inputs.formCustomerClubKeyword.value.length > 0 && <Button variant="link" className="bg-elevate-4 border-0 text-reset btn-icon" onClick={searchResetHandler}><IconFi.FiTrash size={24} className="sw-1"/></Button>}/>
                                </Form>
                            </Col>
                            {
                                data?.shops?.length ? (
                                    data.shops.filter(({title}) => title?.includes(formState.inputs.formCustomerClubKeyword.value)).map((item, index) => {
                                        return (
                                            <Col sm={6} md={4} key={index}>
                                                <Link to={`/${item.type === '1' ? 'shop' : item.type === '2' ? 'dine' : 'entertain'}/${item.id}`} className="text-reset text-decoration-none d-flex flex-column">
                                                    <div className="bg-white">
                                                        <figure className="bg-black bg-opacity-4 ratio ratio-16x9 mb-2">
                                                            {
                                                                item.path ? (
                                                                    <span className="d-flex align-items-center justify-content-center"><img src={`${GlobalConst.cdn}${item.path}`} className="mw-100 mh-100"/></span>
                                                                ) : (
                                                                    <></>
                                                                )
                                                            }
                                                        </figure>
                                                    </div>
                                                    <div className="position-relative percent">
                                                        <div className="position-absolute start-0 bottom-0 mb-3 d-flex flex-column align-items-start">
                                                                <span className="bg-secondary text-accent-3 fw-bold lh-1 d-inline-block px-3 pb-1 mb-2">
                                                                    <span className="ms-2">Coin</span>{item.clubPercent}
                                                                </span>
                                                            {
                                                                item.micaTicketStatus === '20' ? (
                                                                    <span className="bg-secondary text-accent-3 fw-bold lh-1 d-inline-block px-3 pb-1 mt-n1 mb-2">
                                                                            <span className="ms-2">Cash</span>{item.micaTicketPercent}%
                                                                        </span>
                                                                ) : (
                                                                    <></>
                                                                )
                                                            }
                                                            {
                                                                item.micaPlusStatus === '20' ? (
                                                                    <span className="bg-secondary text-accent-3 fw-bold lh-1 d-inline-block px-3 pb-1 mt-n1 mb-2">
                                                                            <span className="ms-2">Credit</span>{item.micaPlusPercent}%
                                                                        </span>
                                                                ) : (
                                                                    <></>
                                                                )
                                                            }
                                                        </div>
                                                    </div>
                                                    {
                                                        item.micaPay === '0' ? (
                                                            <></>
                                                        ) : (
                                                            <span className="position-absolute end-0 top-0 mt-3 d-flex flex-column align-items-start fs-5 percent-2">
                                                                <span className="bg-accent-3 text-secondary fw-bold lh-1 d-inline-block px-3 pb-1">
                                                                    MicaPay
                                                                </span>
                                                            </span>
                                                        )
                                                    }
                                                    <span className="text-truncate fw-500 ls-half ws-n1">{item.title}</span>
                                                    <span className="text-truncate">طبقه {item.floor} غرفه شماره {item.shopNumber}</span>
                                                </Link>
                                            </Col>
                                        )
                                    })
                                ) : (
                                    <NoContent text={`فهرست تعریف نشده است.`}/>
                                )
                            }
                        </Row>
                    </Modal.Body>
                ) : (
                    <Modal.Body className="d-flex justify-content-center align-items-center">
                        <Loader text="در حال دریافت اطلاعات"/>
                    </Modal.Body>
                )
            }
        </Modal>
    )
}

export default ModalCustomerClub;